import React from 'react'
import SlackImage from 'src/images/slack.svg'

const SlackChannel = function () {
  // const title = 'Discuss it further'
  return (
    <>
      {/* <p className='text-xl text-gray-500 pt-4 pb-2 uppercase'>{title}</p> */}
      <div className="border border-gray-400 bg-slate-50 rounded-lg p-4 mb-8">
        <a
          href="https://join.slack.com/t/uxdxcommunity/shared_invite/zt-35pa4p852-BqMGL8z7G3CTP~pd7HqxSw"
          rel="noopener noreferrer"
          target="_blank"
          className="flex"
        >
          <img src={SlackImage} alt="Slack" />
          <p className="ml-4">
            Ask your questions on the <span className="font-medium">#askthespeakers</span> channel
          </p>
        </a>
        <a
          href="https://join.slack.com/t/uxdxcommunity/shared_invite/zt-35pa4p852-BqMGL8z7G3CTP~pd7HqxSw"
          className="m-auto mt-4 inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Join the UXDX Slack Community
        </a>
      </div>
    </>
  )
}

export default SlackChannel
